import React from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import {
    FILTER_PINNED,
    FILTER_NOT_PINNED,
} from 'constants/filters';

export const getPinnedOptions = () => [
    FILTER_PINNED,
    FILTER_NOT_PINNED,
].map(
    value => ({
        text: I18n.t(`filters.pinned_map.${ value }`), // for MultiSelectFilter
        value,
        name: I18n.t(`filters.pinned_map.${ value }`), // for Input[radio]
    })
);

const FilterPinStatus = ({ pin, className }) => {
    let el;
    switch (pin) {
       case FILTER_PINNED:
            el = <Translate value="yes" />;
            break;
        case FILTER_NOT_PINNED:
            el = <Translate value="no" />;
            break;
        default:
            el = <span>--</span>;
    };
    return (
        <div className={ className }>
            { el }
        </div>
    );
};
FilterPinStatus.propTypes = {
    pin: PropTypes.bool,
    className: PropTypes.string,
};
FilterPinStatus.defaultProps = {
    pin: undefined,
    className: undefined,
};
export default FilterPinStatus;
